import { defineAsyncComponent } from 'vue';

const BADepositDetail = defineAsyncComponent(() => import('@/views/deposits/bADeposit/BADepositDetail.vue'));

const BABankTransferDetail = defineAsyncComponent(() =>
  import('@/views/deposits/bABankTransfer/BABankTransferDetail.vue')
);

const BAWithDrawDetail = defineAsyncComponent(() => import('@/views/deposits/bAWithDraw/BAWithDrawDetail.vue'));

const ApproveVoucherBAWithDrawTab = defineAsyncComponent(() =>
  import('@/views/deposits/bAWithDraw/ApproveVoucherBAWithDrawTab.vue')
);

const BATransferDepositDetail = defineAsyncComponent(() =>
  import('@/views/deposits/bATransfer/BATransferDepositDetail.vue')
);

const BATransferWithdrawDetail = defineAsyncComponent(() =>
  import('@/views/deposits/bATransfer/BATransferWithdrawDetail.vue')
);

const ApproveVoucherBABankTransferTab = defineAsyncComponent(() =>
  import('@/views/deposits/bABankTransfer/ApproveVoucherBABankTransferTab.vue')
);

const BADepositeEmisDetail = defineAsyncComponent(() =>
  import('@/views/connectBADepositEmis/BaDepositeEmisDetail.vue')
);

const GenerateEmisResult = defineAsyncComponent(() => import('@/views/connectBADepositEmis/GenerateEmisResult.vue'));

export function registerBA(app) {
  app.component('BADepositDetail', BADepositDetail);
  app.component('BABankTransferDetail', BABankTransferDetail);
  app.component('BAWithDrawDetail', BAWithDrawDetail);
  app.component('ApproveVoucherBAWithDrawTab', ApproveVoucherBAWithDrawTab);
  app.component('BATransferDepositDetail', BATransferDepositDetail);
  app.component('BATransferWithdrawDetail', BATransferWithdrawDetail);
  app.component('ApproveVoucherBABankTransferTab', ApproveVoucherBABankTransferTab);
  app.component('BADepositeEmisDetail', BADepositeEmisDetail);
  app.component('GenerateEmisResult', GenerateEmisResult);
}
